/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
import { Dossier } from '../dossier.model';


export class DossierList {
    items?: Dossier[]; // ecf001
    offset?: number; // ecf001
    limit?: number; // ecf001
    count?: number; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): DossierList {
        if (!data) { return instance; }
        if (data.items != null) {
            instance.items = [];
            ([].concat(data.items)).forEach(occurrence => {
                instance.items.push(new Dossier().fromJSON(occurrence)); // i3
            });
        }
        if (data.offset != null) {instance.offset = data.offset; }
        if (data.limit != null) {instance.limit = data.limit; }
        if (data.count != null) {instance.count = data.count; }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return DossierList.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: DossierList) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return DossierList.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: DossierList): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
